/* global Alpine, Cookies */

const cookieName = 'favourites';

const favourites = () => { // TODO: Do we want to kill this until user has accepted cookies? Hide it?
  Alpine.store('favourites', {
    apiRoot: 'https://johnstones-customer-metafields-912b7159f39a.herokuapp.com',
    init() {
      if (window.Shopify.customerId) {
        this.customerId = window.Shopify.customerId;
        // this.getFromCustomerMetafield();
        this.items = window.Shopify.customerFavourites;
      }
      else {
        this.getFromCookies();
      }
    },
    items: [],
    async getFromCustomerMetafield() { // NOTE: No need for this, just spit the code out in Liquid in a window object.
      await fetch(`${this.apiRoot}/api/favourites-details/${this.customerId}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': 'no-cors'
        },
      })
      .then(res => res.json())
      .then(res => {
        if (res.success && res.data.variants) {
          this.items = res.data.variants.map(i => i.productUrl);
        }
        else {
          this.getFromCookies();
        }
      })
    },
    getFromCookies() {
      const cookie = Cookies.get(cookieName);
      if (cookie) {
        this.items = JSON.parse(cookie);
      }
    },
    writeToCookies() {
      Cookies.set(cookieName,
        JSON.stringify(this.items),
        { expires: 30, path: '/' });
    },
    updateData() {
      if (this.customerId) {
        this.writeToCustomerMetafield();
      }
      else {
        this.writeToCookies();
      }
    },
    writeToCustomerMetafield() {
      if (!this.customerId) return;

      fetch(`${this.apiRoot}/api/update-favourites`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': 'no-cors'
        },
        body: JSON.stringify({
          customerId: this.customerId,
          variantIds: this.items.map(item => item.split('=').pop()),
        })
      })
      .then(res => res.json())
      .then(res => console.log(res))
    },
    getIndex(item) {
      return this.items.indexOf(item);
    },
    add(item) {
      this.items.push(item);
      this.updateData()
    },
    remove(item) {
      const curIndex = this.getIndex(item);
      if (curIndex != -1) {
        this.items.splice(curIndex, 1);
      }
      this.writeToCookies();
      this.writeToCustomerMetafield();
    },
    toggle(item) {
      if (this.getIndex(item) == -1) {
        this.add(item);
      }
      else {
        this.remove(item);
      }
    },

  });
};

export default favourites;
